import React, { useEffect, useState } from "react"
import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get"
import AemGrid from "@/components/AemGrid"
import {
  CORE_GLOBAL_CONFIG_URL,
  PRODUCT_DATA_URL,
  footerUrl,
  headerUrl,
  previewContentPrefix,
  publicWebsiteUrl,
  EMPTY_PIXEL,
} from "@/constants"
import {
  aemApimAxiosInstance,
  aemAxiosInstance,
  aemPreviewAxiosInstance,
} from "@/constants/api"
import { getConfig } from "@/constants/config"
import { useDispatch, useSelector } from "react-redux"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { i18n } from "next-i18next"
import useIsSsr from "@/hooks/useIsSsr"
import { useRouter } from "next/router"
import usePageAuth from "@/hooks/usePageAuth"
import {
  buildUrlForAemApim,
  filterBackEndJson,
  generateCanonicalUrl,
  getClienIP,
  getDataLayerObj,
  removeAndCleanLink,
  updateAnalyticPageUrl,
} from "@/utils/helper"
import { getTeaserFragments } from "@/components/ProductDetail/v3/productDetailsHelper"
import { getProductDetailsFromServer } from "@/utils/product"
import {
  selectGenericState,
  setGbhDataLayerCustom,
} from "@/store/features/genericSlice"
import { selectAuthState } from "@/store/features/authSlice"
import { selectPdpState } from "@/store/features/pdpSlice"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import ProductDetail from "@/components/ProductDetail/v3/ProductDetail"
import PairsWellWith from "@/components/PairsWellWith/PairsWellWith"
import ProductAccordion from "@/components/ProductDetail/v3/ProductAccordion"
import Review from "@/components/Review/v1/Review"
import ProductExf from "@/components/ProductDetail/v3/ProductLandingTeasers/ProductExf"
import PDPLoader from "@/components/ProductDetail/v3/PDPLoader"
import NextHead from "@/components/core/Head/NextHead"
import Script from "next/script"
import Head from "next/head"
import dynamic from "next/dynamic"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"

// const GlobalPageFooter = dynamic(
//   () => import("@/components/Shared/GlobalPage/GlobalPageFooter"),
//   { ssr: false }
// )

function ProductDetailsPage({
  tmpData: data = {},
  headertmp: header,
  footertmp: footer,
  ip,
  globalScript,
  footerScript,
  analyticsData,
  gbhDataLayerCustom,
  slug,
  tmpSkuId: skuId,
  type,
  pdpData,
  apiStatus: status,
  apiStatusText: statusText,
  initialImgAlt,
  initialImgUrl,
  initialImageFullUrl,
  isPart,
  siteName,
  locale,
}) {
  const dispatch = useDispatch()
  const router = useRouter()
  const isSsr = useIsSsr()
  const { access_token: accessToken } = useSelector(selectAuthState)
  const { pageIsInteractive } = useSelector(selectGenericState)
  const { isTeaserLoaded } = useSelector(selectPdpState)
  const [pageRedirect, setPageRedirect] = useState("")
  const { redirectTarget: { page: { path = "" } = {} } = {} } = data
  const [config, setConfig] = useState({})
  const [priceSpiderKey, setPriceSpiderKey] = useState("")
  const [priceSpiderLanguage, setPriceSpiderLanguage] = useState("")
  const [priceSpiderCountry, setPriceSpiderCountry] = useState("")
  useEffect(() => {
    getConfig().then(config => setConfig(config))
    scrollToTop()
    const {
      ProductLocalCategory_s: productLocalCategory = "",
      Product_Category: productCategory = "",
      CustomerFacingSKU_s: skuID = "",
      CustomerFacingBrand_s: siteName = "",
    } = pdpData
    window.needPdpdata = {
      productSubCatergory:
        productLocalCategory.toLowerCase() || productCategory.toLowerCase(),
      skuID,
      siteName: siteName.toLowerCase(),
    }
    if (gbhDataLayerCustom) dispatch(setGbhDataLayerCustom(gbhDataLayerCustom))
    return () => dispatch(setGbhDataLayerCustom(""))
  }, [])
  useEffect(() => {
    if (!_isEmpty(config)) {
      const psKey = _get(config, "general.priceSpiderKey", "")
      if (psKey) {
        setPriceSpiderKey(psKey)
      }
      const psLanguage = _get(config, "internationalization.language", "")
      if (psLanguage) {
        setPriceSpiderLanguage(psLanguage)
      }
      const psCountry = _get(config, "internationalization.country", "")
      if (psCountry) {
        setPriceSpiderCountry(psCountry)
      }
    }
  }, [config])
  useEffect(() => {
    if (ip) sessionStorage.setItem("true-ip", ip)
  }, [ip])
  usePageAuth()
  useEffect(() => {
    if (analyticsData) getDataLayerObj(analyticsData)
  }, [analyticsData])
  useEffect(() => {
    if (path) {
      setPageRedirect(removeAndCleanLink(path))
    }
  }, [path])
  useEffect(() => {
    if (!isSsr && pageRedirect) {
      router.push(pageRedirect)
    }
  }, [isSsr, pageRedirect])
  useEffect(() => {
    if (pdpData && accessToken && pageIsInteractive && !isTeaserLoaded) {
      getTeaserFragments(data, pdpData)
    }
  }, [accessToken, pdpData, pageIsInteractive, isTeaserLoaded])
  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }
  const { language: metaLanguage = "" } = data
  return (
    <>
      <Head>
        <link
          rel="preload"
          href={`https://kohler.scene7.com/is/image/PAWEB/Template_PDP_PLP?$product_src=is{PAWEB/${initialImgUrl}}&$PDPMobile$`}
          as="image"
        />
        <link
          rel="preload"
          href={`https://kohler.scene7.com/is/image/PAWEB/Template_PDP_PLP?$product_src=is{PAWEB/${initialImgUrl}}&$PDPDesktop$`}
          as="image"
        />
      </Head>
      <NextHead
        psKey={priceSpiderKey}
        psCountry={priceSpiderCountry}
        psLanguage={priceSpiderLanguage}
        metaLanguage={metaLanguage}
        pdpData={pdpData}
        isPart={isPart}
        initialImageFullUrl={initialImageFullUrl}
        skuId={skuId}
        siteName={siteName}
      />
      {header ? (
        <GlobalPageHeader
          header={header}
          title={pdpData?.metaTitle_s}
          description={pdpData?.metaDescription_s}
          templateName={data?.templateName}
          globalScripting={globalScript}
        />
      ) : null}
      <Script
        key="zoomdatapdp"
        id="zoomdatapdp"
        src="https://s7d1.scene7.com/s7viewers/html5/js/ZoomViewer.js"
      />
      {data && !_isEmpty(pdpData) ? (
        <div className="min-vh-100">
          <AemGrid
            data={data}
            count={0}
            productDetail={(data, slug, skuId, type) => (
              <ProductDetail
                data={data}
                pdpData={pdpData}
                slug={slug}
                skuId={skuId}
                type={type}
                initialImgAlt={initialImgAlt}
                initialImgUrl={initialImgUrl}
              />
            )}
            productDetailFiller={data => (
              <PDPLoader
                initialImgAlt={initialImgAlt}
                initialImgUrl={initialImgUrl}
                pdpJson={data}
                pdpData={pdpData}
                skuId={skuId}
                data={data}
              />
            )}
            pairsWellWith={data => <PairsWellWith data={data} skuId={skuId} />}
            productAccordion={data => <ProductAccordion data={data} />}
            review={data => <Review data={data} />}
            productExf={data => <ProductExf data={data} />}
            slug={slug}
            skuId={skuId}
            type={type}
          />
        </div>
      ) : null}
      {footer ? (
        <GlobalPageFooter footer={footer} footerScripting={footerScript} />
      ) : null}
    </>
  )
}
/**
 *
 * @return {Object}
 */
export async function getServerSideProps({ req, locale, query }) {
  const { url = "" } = req
  const { leafcategory: slug = "", skuId = "", products = "" } = query
  const isPart = products === ""
  const urlPathWithoutParams = url?.split("?")[0] ?? `/${locale}`
  const { data: configData = {} } = await aemAxiosInstance({
    url: `${CORE_GLOBAL_CONFIG_URL}?caConfig=true&path=/${locale}${urlPathWithoutParams}`,
    method: "GET",
  })
  let profileName = isPart ? `profile_service_parts_PDP` : `profile_kohler_PDP`
  let collections = isPart ? "service_parts" : "kohler"
  if (!_isEmpty(configData)) {
    const {
      general: { serviceParts = "service_parts", siteName = "kohler" } = {},
    } = configData
    const brandName = siteName?.toLowerCase()
    profileName = isPart
      ? `profile_${serviceParts}_PDP`
      : `profile_${brandName}_PDP`
    collections = isPart ? serviceParts : brandName
  }
  let tmpSkuId = skuId
  await i18n?.reloadResources()
  const isPreviewMode = req.cookies["aem-author-preview-mode"]
  const ip = getClienIP(req) ?? ""
  const fullUrl = generateCanonicalUrl(url, locale, publicWebsiteUrl)
  let data
  let apiStatus = 200
  let apiStatusText = ""
  try {
    const response = isPreviewMode
      ? await aemPreviewAxiosInstance({
          url: previewContentPrefix + `/${locale}${PRODUCT_DATA_URL}`,
          method: "GET",
        })
      : await aemApimAxiosInstance({
          url: buildUrlForAemApim(PRODUCT_DATA_URL),
          method: "GET",
        })
    data = response?.data
  } catch (error) {
    const { response: { status = 500, statusText = "" } = {} } = error
    if (status) apiStatus = status
    if (statusText) apiStatusText = statusText
  }
  const {
    globalScript = "",
    footerScript = "",
    pageComponentProperties = {},
    data: rawAnalyticsData = "",
    datalayerPageName = "",
    eventPageType = "",
    headerExpFrg = "",
    footerExpFrg = "",
    siteName = "",
    topHeadScript = null,
  } = data
  const analyticsData = updateAnalyticPageUrl(rawAnalyticsData, fullUrl)
  const { data: header } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: data.headerExpFrg
          ? buildUrlForAemApim(`${data.headerExpFrg}.model.json`)
          : buildUrlForAemApim(`${headerUrl}.model.json`),
        method: "get",
      })
  const { data: footer } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: data.footerExpFrg
          ? buildUrlForAemApim(`${data.footerExpFrg}.model.json`)
          : buildUrlForAemApim(`${footerUrl}.model.json`),
        method: "GET",
      })
  const pdpData = await getProductDetailsFromServer(
    profileName,
    collections,
    slug
  )

  if (_isEmpty(pdpData) || !pdpData) {
    apiStatus = 404
    apiStatusText = "Sorry. We could not find this page."
    return {
      notFound: true,
    }
  } else {
    if (!skuId && !isPart) {
      tmpSkuId = pdpData.masterSKU_s
    }
  }
  let initialImgAlt = ""
  let initialImgUrl = ""
  let initialImageFullUrl = ""
  let tmpData = {}
  if (!_isEmpty(pageComponentProperties)) {
    tmpData = pageComponentProperties
  } else {
    tmpData = data
  }
  if (tmpSkuId) {
    let variants = []
    if (pdpData["variantList.sku_s"]) {
      variants = [pdpData["variantList.sku_s"]]
    } else if (pdpData["variantList.sku_ss"]) {
      variants = pdpData["variantList.sku_ss"]
    }
    const variantImages = pdpData["productImages.labelWithUrl_s"]
      ? [pdpData["productImages.labelWithUrl_s"]]
      : pdpData["productImages.labelWithUrl_ss"]
    let variantImageLabels = []
    let variantImageURLs = []
    if (variantImages?.length) {
      const selVarImageUrls = []
      const selVarImageLabels = []
      variantImages.forEach(img => {
        const imgDetail = img.split("|")
        if (tmpSkuId === imgDetail[0]) {
          selVarImageLabels.push(imgDetail[4] ?? "")
          selVarImageUrls.push(
            imgDetail[imgDetail.length - 1]
              ? imgDetail[imgDetail.length - 1]
              : EMPTY_PIXEL
          )
        } else if (!variants.find(v => v === imgDetail[0])) {
          variantImageLabels.push(imgDetail[4] ?? "")
          variantImageURLs.push(
            imgDetail[imgDetail.length - 1]
              ? imgDetail[imgDetail.length - 1]
              : EMPTY_PIXEL
          )
        }
      })
      variantImageLabels = [...selVarImageLabels, ...variantImageLabels]
      variantImageURLs = [...selVarImageUrls, ...variantImageURLs]
      if (variantImageURLs.length < 1) {
        variantImageLabels.push(tmpSkuId)
        variantImageURLs.push(EMPTY_PIXEL)
      }
    } else {
      variantImageLabels.push(tmpSkuId)
      variantImageURLs.push(EMPTY_PIXEL)
    }
    const assetIdArray = variantImageURLs
      ? variantImageURLs[0].split("PAWEB/")
      : [""]
    initialImgAlt = variantImageLabels[0]
    initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : ""
    initialImageFullUrl =
      variantImageURLs.find(image => image.includes(initialImgUrl)) ?? ""
  }
  const gbhDataLayerCustom = {}
  if (datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = datalayerPageName
  }
  if (eventPageType) {
    gbhDataLayerCustom.eventPageType = eventPageType
  }
  if (data?.pageType) {
    gbhDataLayerCustom.pageType = data?.pageType
  }
  if (data) tmpData = filterBackEndJson(tmpData)
  let headertmp
  if (header) headertmp = filterBackEndJson(header)
  let footertmp
  if (footer) footertmp = filterBackEndJson(footer)
  return {
    props: {
      ip,
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      footerScript,
      analyticsData,
      gbhDataLayerCustom,
      topHeadScript,
      slug,
      tmpSkuId,
      pdpData,
      ...(await serverSideTranslations(locale, ["pdp"])),
      apiStatus,
      apiStatusText,
      initialImgAlt,
      initialImgUrl,
      initialImageFullUrl,
      fullUrl,
      isPart,
      siteName,
      locale,
    },
  }
}
export default ProductDetailsPage
